import { useNavigate } from 'react-router-dom';
import { LockClosedIcon } from '@heroicons/react/24/outline';
import { Button } from './ui';

interface AccessDeniedProps {
	/** Optional line explaining which capability is missing. */
	message?: string;
	/** Where "Go Back" lands. Defaults to browser history. */
	fallbackPath?: string;
}

/**
 * Shown instead of a redirect when a signed-in user reaches a page their role
 * does not grant. A redirect would silently swallow the attempt; an explicit
 * message tells them to ask their provider for the permission.
 */
const AccessDenied = ({ message, fallbackPath }: AccessDeniedProps) => {
	const navigate = useNavigate();

	return (
		<div className="flex flex-col items-center justify-center text-center py-20 px-6">
			<div className="w-20 h-20 rounded-full bg-red-50 dark:bg-red-900/20 flex items-center justify-center mb-6">
				<LockClosedIcon className="w-10 h-10 text-red-500 dark:text-red-400" />
			</div>
			<h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Access Denied</h1>
			<p className="text-gray-500 dark:text-gray-400 max-w-md mb-6">
				{message ??
					"You don't have permission to view this page. Contact your provider if you need access."}
			</p>
			<Button
				variant="secondary"
				onClick={() => (fallbackPath ? navigate(fallbackPath) : navigate(-1))}
			>
				Go Back
			</Button>
		</div>
	);
};

export default AccessDenied;
